
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/iyaiya",
      function () {
        return require("private-next-pages/blog/iyaiya.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/iyaiya"])
      });
    }
  